import { createAction, handleActions } from 'redux-actions';
import {
  api_attribute,
  api_attribute_questions_usage,
} from '../../constants/apiRoutes';
import http from '../../utility/http';
import { setIsUsedInSurveyField } from '../../utility/helpers';
// ------------------------------------
// Constants
// ------------------------------------

const SET_ATTRIBUTE = 'SET_ATTRIBUTE';

const initialState = {
  attribute: {
    questions: [],
  },
};

// ------------------------------------
// Actions
// ------------------------------------params
export const setAttribute = createAction(SET_ATTRIBUTE);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_ATTRIBUTE]: (state, { payload }) => {
    return {
      attribute: { ...state.attribute, ...payload },
    };
  },
};

// ------------------------------------
// API calls
// ------------------------------------

export const updateAttribute = (dispatch, id, updatedData) => {
  return http.patch(api_attribute(id), updatedData).then(({ data }) => {
    dispatch(setAttribute(data));
  });
};

export const getAttribute = (
  dispatch,
  id,
  params = {},
  checkQuestionUsage = false
) => {
  return http.get(api_attribute(id), { params }).then(({ data }) => {
    if (checkQuestionUsage) {
      return http.get(api_attribute_questions_usage(id)).then(questionUsage => {
        const updatedData = setIsUsedInSurveyField(data, questionUsage?.data);

        dispatch(setAttribute(updatedData));
        return updatedData;
      });
    }
    dispatch(setAttribute(data));
    return data;
  });
};

export const setAttributeQuestions = (dispatch, id, updatedQuestion) => {
  const { tags, ...attr } = updatedQuestion;

  return http.patch(api_attribute(id), attr).then(() => {
    dispatch(setAttribute(updatedQuestion));
  });
};

export default handleActions(reducers, initialState);

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearAttribute = () => setAttribute(initialState.attribute);
